/**
 * Business Card Import API Service
 */

import { apiClient } from '../client';
import type {
  ApiResponse,
  PartnerCategory,
  BizcardImportRequest,
  BizcardOcrResponse,
  BizcardConfirmRequest,
  BizcardImportResult,
  BizcardPartnerListItem,
} from '../../types';

const API_PREFIX = '/api/saiens/bizcard';

/**
 * Get partner categories list for bizcard import
 */
export async function getPartnerCategories(): Promise<ApiResponse<PartnerCategory[]>> {
  const response = await apiClient.get<ApiResponse<PartnerCategory[]>>(
    `${API_PREFIX}/categories`
  );
  return response.data;
}

/**
 * OCR scan business card image (does not write to DB)
 */
export async function importBizcard(
  data: BizcardImportRequest
): Promise<ApiResponse<BizcardOcrResponse>> {
  const response = await apiClient.post<ApiResponse<BizcardOcrResponse>>(
    `${API_PREFIX}/import`,
    data
  );
  return response.data;
}

/**
 * Confirm OCR result and write to DB
 */
export async function confirmBizcard(
  data: BizcardConfirmRequest
): Promise<ApiResponse<BizcardImportResult>> {
  const response = await apiClient.post<ApiResponse<BizcardImportResult>>(
    `${API_PREFIX}/confirm`,
    data
  );
  return response.data;
}

/**
 * Get recent bizcard imported partners
 */
export async function getBizcardPartners(
  limit?: number
): Promise<ApiResponse<BizcardPartnerListItem[]>> {
  const response = await apiClient.get<ApiResponse<BizcardPartnerListItem[]>>(
    `${API_PREFIX}/partners`,
    { params: { limit } }
  );
  return response.data;
}
